import { render, staticRenderFns } from "./PopupUpdate.vue?vue&type=template&id=29e5c970&"
import script from "./PopupUpdate.vue?vue&type=script&lang=js&"
export * from "./PopupUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports